'use strict';
var processInclude = require('base/util');

$(document).ready(function() {
    processInclude(require('../product/quickView'));
    processInclude(require('wishlists/wishlist'));
});

$(document).on('click', '.pdp-sizeGuide-modal .close', function() {
    $('#pdp-sizeGuide').remove();
});
$(document).on('click', '.edit-add-to-wishlist .edit', function(e) {
    e.preventDefault();
    $('#editWishlistProductModal .modal-header:first-child').addClass('d-lg-none');
    $('#editWishlistProductModal .modal-dialog').addClass('modal-dialog-centered');
    /* re-bind the  click event listener when opening the wishlist edit overlay */
    $('button.add-to-cart-global').on('click');
});
$(document).on('click', '.select-attributes-btn', function(e) {
    e.preventDefault();
    $('#editWishlistProductModal .modal-header:first-child').addClass('d-lg-none');
    $('#editWishlistProductModal .modal-dialog').addClass('modal-dialog-centered');
});
$(document).on('show.bs.modal', '#editWishlistProductModal', function() {
    $('.pdp-sizeGuide-modal .close').removeAttr('data-dismiss');
    $('.modal-body .swatch-circle').each(function(i, d) {
        if ($(d).hasClass('selected')) {
            var swatchVal = $(d).data('attr-value');
            $('.selected-color').text(swatchVal.toLowerCase());
        }
    });
});
